import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='PORCENTAJE' md={5} alignRightAt='md' />
      <Col md={7}>
        <Form.InputNumber
          value={iValue}
          id='number-porcentajeDetraccion'
          name='number-porcentajeDetraccion'
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFormGroup)
